export const REPORT_COLORS = ["#7161d1", "#71b955", "#df5f75", "#edbf45", "#4e93cb", "#36aeaa", "#a4bb43", "#b577c1", "#df9354", "#599379", "#cd7095", "#7e9dce", "#c3b340", "#a47969", "#8d8cce", "#94b99b"];
export const reportColor = (index) => REPORT_COLORS[index % REPORT_COLORS.length];
export const percent = (value, total) => new Intl.NumberFormat("nl-BE", { maximumFractionDigits: 1 }).format(total ? value / total * 100 : 0);

const csvCell = (value) => {
  const text = String(value ?? "");
  const safe = /^[\s]*[=+@-]|^[\t\r\n]/.test(text) ? `'${text}` : text;
  return `"${safe.replaceAll('"', '""')}"`;
};

export function downloadReportCsv(rows, label, filename, filters) {
  const total = rows.reduce((sum, row) => sum + row.stuks, 0);
  const csv = [[label, "Stuks", "Aandeel (%)"], ...rows.map((row) => [row.naam, row.stuks, percent(row.stuks, total)]), ["Totaal", total, total ? "100" : "0"]]
    .map((row) => row.map(csvCell).join(";")).join("\r\n");
  const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob), link = document.createElement("a");
  const period = filters.vanaf || filters.tot ? `_${filters.vanaf || "begin"}_${filters.tot || "heden"}` : "";
  link.href = url; link.download = `ctn_${filename}${period}.csv`;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}